import { Button, Stack } from "react-bootstrap";
import Motivo from "./Motivo";
import { formatRut } from "../../validations/format";
import { useNavigate } from "react-router-dom";
import Flag from "./Flag";
import { useState } from "react";

function UsuarioEnEspera({ usuario, onAtender, styles, actual }) {
  const navigate = useNavigate();

  const handleVerFicha = () => {
    navigate(`/atencion/ficha/${usuario.solicitante.idS}`);
  };
  
  // Si tiene pasaporte, mostrar el RUT tal cual; si no, formatearlo
  const displayRut = usuario.solicitante 
    ? (usuario.solicitante.pasaporte 
        ? usuario.solicitante.rut 
        : formatRut(usuario.solicitante.rut))
    : "";
  
  return (
    <tr>
      <td>
        <strong>{usuario.numero_ticket || "-"}</strong>
      </td>
      <td>
        <Motivo motivo={usuario.motivo?.nombre} />
      </td>
      <td>
        <Stack direction="horizontal" gap={1} className="align-items-left">
          <Flag
            key={usuario.solicitante.flag} // Forzar re-render al cambiar flag desde el GET externo
            idSolicitante={usuario.solicitante.idS}
            initialFlag={usuario.solicitante.flag}
            size={25}
          />

          {usuario.solicitante ? usuario.solicitante.nombre : ""}
        </Stack>
      </td>
      <td>
        {usuario.solicitante
          ? usuario.solicitante.pasaporte
            ? usuario.solicitante.rut
            : formatRut(usuario.solicitante.rut)
          : ""}
      </td>
      <td>
        <div className="d-flex flex-column flex-md-row gap-2">
          <Button
            className="btn-primary-blue"
            size="sm"
            onClick={handleVerFicha}
          >
            Ver ficha
          </Button>

          <Button
            variant="success"
            size="sm"
            onClick={() =>
              onAtender(usuario.ticket_id, usuario.solicitante.idS)
            }
            disabled={!!(actual && actual.atencion)}
          >
            Atender
          </Button>
        </div>
      </td>
    </tr>
  );
}

export default UsuarioEnEspera;
